// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"85":"8731288e","166":"584fc64e","518":"fafa7164","819":"ae6b2816"}[chunkId] + ".js";
};